export function useOrderData() {
    const orderData = useCookie('orderData')

    function setOrderData(data: any) {
        orderData.value = data
    }

    function getOrderData() {
        return orderData
    }

    return { setOrderData, getOrderData }
}